import { ReduxState } from 'modules/jobManager/types';

const getJobManagerReduxState = (state: Record<string, any>) => state.jobManager as ReduxState;

export const getJobManagerTableData = (state: Record<string, any>) =>
  getJobManagerReduxState(state).tableData;

export const getJobManagerTableFilter = (state: Record<string, any>) =>
  getJobManagerReduxState(state).tableFilters;

export const getJobManagerTableSort = (state: Record<string, any>) =>
  getJobManagerReduxState(state).tableSort;

export const getJobManagerTablePagination = (state: Record<string, any>) =>
  getJobManagerReduxState(state).tablePagination;

export const getJobManagerTableSearch = (state: Record<string, any>) =>
  getJobManagerReduxState(state).tableSearch;

export const getJobCreationTakeoverState = (state: Record<string, any>) =>
  getJobManagerReduxState(state).creationTakeover;
